import { useDispatch } from 'react-redux';
import { store } from './index';

export type InferValueTypes<T> = T extends { [key: string]: infer U } 
  ? U 
  : never;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>(); 